// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6 4.93V4.2C6 3.1 6.9 2.2 8 2.2C9.1 2.2 10 3.1 10 4.2V4.93M6.45 2.9L5.1 1.5M9.55 2.9L10.9 1.5',
  'M4.31 6.54C2.95 6.22 2 5.35 2 3.8M11.69 6.54C13.05 6.22 14 5.35 14 3.8M4.13 9.25H1.5M11.87 9.25H14.5M4.43 11.92C2.96 12.13 2 13.05 2 14.5M11.57 11.92C13.04 12.13 14 13.05 14 14.5',
  'M7 4.95H9C10.46 4.95 11.65 6.14 11.65 7.6V10.35C11.65 12.37 10.02 14 8 14C5.98 14 4.35 12.37 4.35 10.35V7.6C4.35 6.14 5.54 4.95 7 4.95Z',
  'M8 7.7V13.8',
];
